import * as d3 from 'd3';

const mapData = (keys, scores, trendScores) => {
  return d3.stratify()([
    ...keys.map(key => {
      return {
        id: key,
        label: key,
        parentId: 'container',
        value: d3.sum(scores[key], d => d.amount),
        score: trendScores[key].current,
        trend: trendScores[key].trend,
      };
    }),
    {
      id: 'container',
      score: null,
    },
  ]);
};

export default mapData;



// WEBPACK FOOTER //
// ./src/components/CirclePackingChart/mapData.js